@let obs =
  {
    selectedUnitCode: selectedUnitCode$ | async,
    selectedUnitName: selectedUnitName$ | async,
    isOpen: isOpen$ | async,
  };

<div
  class="dropdown-container"
  (sdClickOutside)="closeDropdown()"
  (click)="onDropdownClick($event)"
  data-ignore-product-details-redirect="true"
>
  <div class="dropdown-list text-md-b4-m-500 text-lg-b2-s-500" [class.dropdown-list-closed]="!obs.isOpen">
    @if (units.length > 1) {
      <div (click)="toggleDropdown()">
        {{ obs.selectedUnitName }}

        <sd-icon [type]="obs.isOpen ? 'arrow-up' : 'arrow-down'"></sd-icon>
      </div>
    } @else {
      <div class="one-unit">{{ obs.selectedUnitName }}</div>
    }

    @if (units.length > 1) {
      @for (unit of units; track unit.baseUnit.code) {
        @if (unit.baseUnit.code !== obs.selectedUnitCode) {
          <div (click)="selectUnitCode(unit.baseUnit.code)">
            {{ unit.baseUnit.name }}
          </div>
        }
      }
    }
  </div>
</div>
